/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './BattleDBvalue.css';
import ReactEcharts from 'echarts-for-react'






class BattleDBvalue extends React.Component {

  constructor(props){
    super(props)
    this.state={}
    this.getOption=this.getOption.bind(this)
  }



  getOption=()=>{

    console.log(this.props.json)
    


    let propsData=this.props.json||[
        {
          name:'腾讯',
          value:[100,200,300,400]
        },{
          name:'阿里巴巴',
          value:[400,200,100,200]
        },{
          name:'美的',
          value:[200,300,100,500]
        }
    ]




    let legendArr=[]

    propsData.forEach((i)=>{
        legendArr.push(`${i.name}`)
    })

    // console.log(legendArr)




    const option = {
      title:{
        // text:`DB总值构成图 - ${this.props.items.name}`,
        text:`${this.props.db?'DB值':'DB总值'}构成图 - ${legendArr.join(' vs ')}`,
        subtext:'数据来源：数字品牌榜',
        x:'20'
      },
      color:['#ffd70d','#608f9f','#014d67','#56b5a0','#248e76'],
      
      tooltip : {
          trigger: 'axis',
          axisPointer : {            // 坐标轴指示器，坐标轴触发有效
              type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          }
      },
      legend: {
          data:legendArr,
      },
      toolbox: {
        show: true,
        feature: {
            restore: {},
            saveAsImage: {}
        },
        right: 20
      },
      grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
      },
      xAxis : [
          {
              type : 'category',
              data : ['微信','微博','知乎','今日头条']
          }
      ],
      yAxis : [
          {
              type : 'value'
          }
      ],
      // series : [
      //     {
      //         name:'腾讯',
      //         type:'bar',
      //         data:[320, 332, 301, 334,]
      //     },
      //     {
      //         name:'阿里巴巴',
      //         type:'bar',
              
      //         data:[120, 132, 101, 134, ]
      //     },
      //     {
      //         name:'美的',
      //         type:'bar',
          
      //         data:[220, 182, 191, 234,]
      //     },
          
      // ],
      series:propsData.map((i)=>{
        return {
          data:i.value,
          name:i.name,
          type:'bar'
        }
      })
    }

    return option

  }

  render() {
    return (<ReactEcharts
      option={this.getOption()}
      style={{
      height: '550px',
      width: '100%',
      
      borderRadius: '4px'
      }}
      className={s.charts}
      notMerge={true}
      lazyUpdate={true}
      theme={"theme_name"}
      onChartReady={this.onChartReadyCallback}/>)


   
  }
}

export default withStyles(s)(BattleDBvalue);



// WEBPACK FOOTER //
// src/components/BattleDBvalue/BattleDBvalue.js